import { render, staticRenderFns } from "./RejectEnvelopeModal.vue?vue&type=template&id=28717a4f&lang=pug"
import script from "./RejectEnvelopeModal.vue?vue&type=script&lang=js"
export * from "./RejectEnvelopeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports